import { AiQuestionWrapper, AiQuestionCriteria, AiQuestionScenario, AiQuestion } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { Model } from '../../model/model';

/**
 * Appels Questions IA 
 * Author LMA
 */
export class IaQuestionCmd extends WizCommand<AiQuestionWrapper> {

  protected model: Model = null;
  
  public static readonly AI_QUESTION_API: string = 'aiquestion.do';

  constructor(model: Model) {
    super();
    this.model = model;
  } 
  
  /** méthode appelée au retour de la commande */
  public sourceCallback: Function;
  public method: string;

  /** retourne un wrapper pre-alimenté */
  public aiQuestionWrapper(): AiQuestionWrapper {
    const wrapper: AiQuestionWrapper = new AiQuestionWrapper();
    wrapper.criteria = new AiQuestionCriteria();
    wrapper.scenario = new AiQuestionScenario();
    wrapper.criteria.domain = this.model.currentDomainCode;
    wrapper.criteria.businessUnitCode = this.model.currentBUCode;
    wrapper.scenario.languageCode = this.model.currentLocaleCode;
    return wrapper;
  }


  /** chargement spécifique sur contextGuard */
  public find(sourceCallback: Function = null): IaQuestionCmd {
    const wrapper: AiQuestionWrapper = this.aiQuestionWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.method = WIZ_COMMAND_METHOD.FIND;
    
    this.configureRemote(IaQuestionCmd.AI_QUESTION_API, wrapper);
    this.sourceCallback = sourceCallback;
    return this;
  }

  /** create d'une question */
  public update(q: AiQuestion, sourceCallback: Function = null): IaQuestionCmd {
    const wrapper: AiQuestionWrapper = this.aiQuestionWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.UPDATE;
    this.method = WIZ_COMMAND_METHOD.UPDATE;
    
    wrapper.entity = q;
    wrapper.entity.domain = this.model.domainCode;
    wrapper.entity.businessUnitCode = this.model.businessUnitCode;
    

    this.configureRemote(IaQuestionCmd.AI_QUESTION_API, wrapper);
    this.sourceCallback = sourceCallback;
    return this;
  }

  /** sur retour, traitement selon la méthode */
  public wizResult() {
    super.wizResult();

    const wrapper: AiQuestionWrapper = this.result;
    
    if(!!wrapper) {
      if (wrapper.method === WIZ_COMMAND_METHOD.FIND) {
        console.log('TODOTODO feed', this.result.entities) 
      }
  
      if (this.sourceCallback != null) { // retour sur update
        this.sourceCallback(this.result.entity);
      }
    } else {
      console.log('IaQuestionCmd error');
    }


  }

}
